export class Format {
  static asCurrency(value) {
    const num = Number(value);
    
    if (isNaN(num)) return '$0.00'; // Fallback for invalid inputs

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }

  static asDate(date) {
    const dateObj = new Date(date);

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return dateObj.toLocaleDateString(undefined, options);
  }
}